const TimeIcon = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99984 3.49996V6.99996L9.33317 8.16663M12.8332 6.99996C12.8332 10.2216 10.2215 12.8333 6.99984 12.8333C3.77818 12.8333 1.1665 10.2216 1.1665 6.99996C1.1665 3.7783 3.77818 1.16663 6.99984 1.16663C10.2215 1.16663 12.8332 3.7783 12.8332 6.99996Z"
      stroke="#686576"
      strokeWidth={1.16667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TimeIcon;